import React from 'react'

export const Emptycart = () => {
  return (
    <div>
    <div>
        <img style={{width:"500px",height:"300px",marginLeft:"500px",marginTop:"70px"}} src="/images/em2.png" alt="" srcset="" />
        <div style={{fontSize:"30px",textAlign:"center"}}>
            YOUR CART IS EMPTY
            <div>
                ADD SOMTHING TO MAKE ME HAPPY :)
            </div>
        </div>
    </div>
   
    </div>
  )
}
